import { MessageBox } from 'element-ui';
// 处理路由跳转前操作
import NProgress from 'nprogress'; // progress bar
function guardRaptureUrl(emitter, next) {
    return emitter.routerRaptureSign.forEach(props => {
        // 如果没有事件，即直接返回next
        if (emitter.queue[props]) {
            next(false); // 物理点击返回按钮，保证url不变
            emitter
                .emit(props)
                .then(() => {
                next();
            })
                .catch(msg => {
                // vue-router有个afterEach异步事件，会顶掉弹窗显示，异步弹出
                setTimeout(() => {
                    MessageBox.confirm(`${msg ? msg : '退出后编辑过的内容将不保存'}`, '确认要退出该页面吗', {
                        confirmButtonText: '放弃编辑',
                        cancelButtonText: '继续编辑',
                        type: 'warning',
                    })
                        .then(() => {
                        emitter.queue = [];
                        next();
                    })
                        .catch(() => {
                        emitter.timer && clearInterval(emitter.timer);
                        NProgress.done(); // finish progress bar
                    });
                }, 50);
            });
        }
        else {
            next();
        }
    });
}
export default guardRaptureUrl;
